import { Field, useFormikContext } from 'formik'
import cn from 'classnames'
import Fuse from 'fuse.js'
import { isEmpty } from 'lodash'

import TextBox from 'components/TextBox'
import NumberBox from 'components/NumberBox'
import Toggle from 'react-toggle'
import Select from 'components/Select'

import {
  VENUE_SETTINGS_FIELDS_REQUIRED_CONFIRMATION,
  venueSettingsItems,
} from 'resources'
import { FUSE_OPTIONS } from 'utils/fuseSettings'
import { venueSettingsUtils } from 'components/VenueSettings/utils'

const VenueSettings = ({
  searchQuery,
  setModalType,
  showValidationErrors,
}) => {
  const { setFieldValue, values, initialValues } = useFormikContext()

  const isTextColorDanger = (name) => {
    return (
      VENUE_SETTINGS_FIELDS_REQUIRED_CONFIRMATION.includes(name) &&
      initialValues?.[name] === true
    )
  }

  const isFieldDisabled = (name) => {
    switch (name) {
      // if enable_pos_sms_receipts is disabled, sms_receipt_message should be disabled as well
      case 'sms_receipt_message':
        return !values?.enable_pos_sms_receipts
      default:
        return false
    }
  }

  const filteredVenueSettingsItems = isEmpty(searchQuery)
    ? venueSettingsItems
    : new Fuse(venueSettingsItems, FUSE_OPTIONS)
        .search(searchQuery)
        .map((item) => item.item)

  const actions = {
    handleClickCustomTipConfiguration:
      venueSettingsUtils.handleClickCustomTipConfiguration(
        setModalType
      ),
  }

  return (
    <section className="venue-settings">
      {filteredVenueSettingsItems.map(
        ({
          title,
          description,
          name,
          type,
          options,
          label,
          action,
        }) => {
          return (
            <article key={title} className="venue-settings__setting">
              <div
                className={cn('venue-settings__text', {
                  '-text-error': isTextColorDanger(name),
                })}
              >
                <header>
                  <h5 className="venue-settings__title">{title}</h5>
                </header>
                <p
                  className={cn('venue-settings__description', {
                    '-text-error': isTextColorDanger(name),
                  })}
                >
                  {description}
                </p>
              </div>
              <div
                className={cn('venue-settings__input', `-${type}`)}
              >
                {type === 'number' && (
                  <NumberBox
                    name={name}
                    value={values[name]}
                    min="0"
                    onChangeAdd={() => {
                      setFieldValue(name, Number(values[name]) + 1)
                    }}
                    onChangeMinus={() => {
                      if (values[name] === 0) {
                        return
                      }

                      setFieldValue(name, Number(values[name]) - 1)
                    }}
                    onChange={(e) =>
                      setFieldValue(name, e.target.value)
                    }
                  />
                )}
                {type === 'checkbox' && (
                  <Field
                    component={Toggle}
                    checked={values[name]}
                    name={name}
                    onChange={(event) => {
                      setFieldValue(name, event.target.checked)
                    }}
                  />
                )}
                {type === 'text' && (
                  <Field component={TextBox} masked name={name} />
                )}
                {type === 'textarea' && (
                  <Field
                    component={TextBox}
                    textarea
                    name={name}
                    showValidationErrors={showValidationErrors}
                    disabled={isFieldDisabled(name)}
                  />
                )}
                {type === 'select' && (
                  <Field
                    component={Select}
                    handleChange={(value) =>
                      setFieldValue(name, value)
                    }
                    label={title}
                    options={options}
                    defaultValue={values[name]}
                    name={name}
                    key={values[name]}
                  />
                )}
                {type === 'button' && (
                  <button
                    type="button"
                    className="btn -outline"
                    onClick={actions[action]}
                  >
                    {label}
                  </button>
                )}
              </div>
            </article>
          )
        }
      )}
    </section>
  )
}

export default VenueSettings
